/** @format */

import axios from "axios";
import { Input, message } from "antd";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";

import print from "../../../../icons/print.png";
import LoadingCard from "../../../../components/loading/loadingCard";
import { monthDays, monthName } from "../../../../components/functions/Month";
import { getEnv } from "../../../../lib/env";

function Kunlik({ vaqt, havza }) {
  const conponentPDF = useRef();
  const [data, setData] = useState({ manbalar: [] });
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("sw_user_token");
      if (!token) return;

      setLoading(true);
      try {
        const dateParam = month.replace(/-/g, "") + "01";
        const res = await axios.get(
            `${getEnv('REACT_APP_BASE_URL')}/v1/itb/manbalar/kunlik?date=${dateParam}&vaqt=${vaqt}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data) {
          setData(res.data);
        }
      } catch (e) {
        message.error("Ma'lumotlarni yuklashda xatolik!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [month, vaqt, havza]);

  const daysArray = useMemo(() => {
    const count = monthDays(month);
    return Array.from({ length: count }, (_, i) => {
      const day = i + 1;
      const formattedDay = day < 10 ? `0${day}` : day;
      return `${month.replace(/-/g, "")}${formattedDay}`;
    });
  }, [month]);

  const filteredManbalar = useMemo(() => {
    if (!data.manbalar) return [];
    if (!searchTerm) return data.manbalar;
    return data.manbalar.filter((item) =>
        item.manba_nomi?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [data.manbalar, searchTerm]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Kunlik ma'lumotlar",
  });

  const calculateTotal = (dateKey) => {
    return filteredManbalar.reduce((acc, curr) => {
      const value = curr.suvi ? curr.suvi[dateKey] : null;
      return acc + (Number(value) || 0);
    }, 0);
  };

  return (
      <div className="table-box">
        <div className="table-content-top">
          <div className="table-top-left">
            <Input
                prefix={<SearchOutlined />}
                placeholder="Qidiruv..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <ul className="table-top-right">
            <li>
              <NavLink to="/asosiymanbalar/add" className="btn btn-sm btn-outline-primary">
                Ma'lumot kiritish <PlusOutlined />
              </NavLink>
            </li>
            <li>
              <input
                  type="month"
                  className="form-control form-control-sm"
                  value={lmonth}
                  onChange={(e) => {
                    setLmonth(e.target.value);
                    setMonth(e.target.value);
                  }}
              />
            </li>
            <li>
              <button className="btn p-0" onClick={generatePDF}>
                <img src={print} alt="print" width={22} />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
            <LoadingCard loading={loading} heightSize="80vh" />
        ) : (
            <div id="content" style={{ height: "82vh", overflow: "auto" }}>
              <div ref={conponentPDF}>
                <table className="table table-bordered table-style custom-fixed-table">
                  <thead>
                  <tr className="bg-primary text-white">
                    <th rowSpan={2} className="sticky st1" style={{ left: 0, top: 0, zIndex: 10 }}>#</th>
                    <th rowSpan={2} className="sticky st2" style={{ left: "31px", top: 0, zIndex: 10 }}>T/R</th>
                    <th rowSpan={2} className="sticky st3" style={{ left: "72px", top: 0, zIndex: 10 }}>Manba nomi</th>
                    <th rowSpan={2} className="sticky st4" style={{ left: "396px", top: 0, zIndex: 10 }}>Birlik</th>
                    <th colSpan={daysArray.length} className="text-center">{monthName(month)}</th>
                  </tr>
                  <tr className="bg-primary text-white">
                    {daysArray.map((date) => (
                        <th key={date} className="day-column">{date.slice(-2)}</th>
                    ))}
                  </tr>
                  </thead>
                  <tbody>
                  {filteredManbalar.map((item, idx) => (
                      <React.Fragment key={item.id || idx}>
                        {/* AGAR TITLE BO'LSA TUMAN NOMINI CHIQARISH */}
                        {item.title && (
                            <tr className="bg-light">
                              <td colSpan={4 + daysArray.length} className="text-center ps-3 fw-bold text-danger">
                                {item.title}
                              </td>
                            </tr>
                        )}
                        <tr className={`tr ${selectedId === item.id ? "active" : ""}`}>
                          <td className="sticky st1" style={{ left: 0 }}>
                            <input
                                type="checkbox"
                                checked={selectedId === item.id}
                                onChange={() => setSelectedId(item.id)}
                            />
                          </td>
                          <td className="sticky st2" style={{ left: "31px" }}>{item.tartibi || idx + 1}</td>
                          <td className="sticky st3 text-start ps-3" style={{ left: "72px", width: "324px", fontWeight: item.formula ? 'bold' : 'normal' }}>
                            {item.manba_nomi}
                          </td>
                          <td className="sticky st4 text-start" style={{ left: "396px" }}>{item.birligi}</td>
                          {daysArray.map((dateKey) => (
                              <td key={dateKey} className="day-column">
                                {item.suvi && item.suvi[dateKey] !== null ? item.suvi[dateKey] : "-"}
                              </td>
                          ))}
                        </tr>
                      </React.Fragment>
                  ))}

                  {/* JAMI QATORI */}
                  <tr className="fw-bold" style={{ backgroundColor: "#f8f9fa" }}>
                    <td colSpan={4} className="sticky text-center fw-bold" style={{ left: 0, zIndex: 3 }}>JAMI:</td>
                    {daysArray.map((dateKey) => {
                      const total = calculateTotal(dateKey);
                      return (
                          <td key={dateKey} className="day-column">
                            {total > 0 ? total.toFixed(2) : "-"}
                          </td>
                      );
                    })}
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
        )}

        <style>{`
        .custom-fixed-table {
          table-layout: fixed;
          width: max-content;
          min-width: 100%;
          border-collapse: separate;
          border-spacing: 0;
        }
        .custom-fixed-table thead th {
          position: sticky !important;
          top: 0;
          background-color: #0b4aa9 !important;
          color: #fff;
          z-index: 5;
          border: 1px solid #dee2e6;
        }
        .custom-fixed-table thead tr:nth-child(2) th {
          top: 35px;
          z-index: 5;
        }
        .sticky {
          position: sticky !important;
          background-color: #fff;
          z-index: 2;
        }
        thead .sticky {
          z-index: 10 !important;
        }
        .day-column {
          width: 60px !important;
          min-width: 60px !important;
          text-align: center;
          font-size: 12px;
        }
        .tr.active {
          background-color: #e6f7ff !important;
        }
        .custom-fixed-table th, .custom-fixed-table td {
          border: 1px solid #dee2e6;
        }
      `}</style>
      </div>
  );
}

export default Kunlik;